import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

import { LegalModalComponent } from '../legal-modal/legal-modal';
import { ThemeService } from '../../core/theme/theme.service';
import { IconComponent } from '../icon/icon';

@Component({
  selector: 'app-footer',
  imports: [MatButtonModule, MatDialogModule, IconComponent],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class.dark]': 'isDark()' },
})
export class FooterComponent {
  private readonly dialog = inject(MatDialog);
  protected readonly isDark = inject(ThemeService).isDark;

  openLegal(type: 'terms' | 'privacy'): void {
    this.dialog.open(LegalModalComponent, { data: { type }, maxWidth: '720px', width: '90vw' });
  }
}
